<div class="tabbed">
  <div class="pane-header">
    <h3 class="title">Select video</h3>
    <div class="segments">
      <nav role="tablist" class="tab-selectors tab-selectors--primary edit-form-nav">
        <label class="tab-selector tab-selector--first" for="video-edit" role="tab">
          <input class="tab-selector-radio" type="radio" value="video-edit" id="video-edit" name="video-dialog-tab" data-behaviour="tabstate" aria-controls="video-edit-tab">
          <span class="tab-label">Edit</span>
        </label>
        <label class="tab-selector" for="video-search" role="tab">
          <input class="tab-selector-radio" type="radio" value="video-search" id="video-search" name="video-dialog-tab" data-behaviour="tabstate" aria-controls="video-search-tab">
          <span class="tab-label">Library</span>
        </label>
        <label class="tab-selector tab-selector--last" for="video-upload" role="tab">
          <input class="tab-selector-radio" type="radio" value="video-upload" id="video-upload" name="video-dialog-tab" data-behaviour="tabstate" aria-controls="video-upload-tab">
          <span class="tab-label">Upload</span>
        </label>
      </nav>
    </div>
    <div class="actions">
      <span class="close">
        {{{ icon 'close' 'Close' }}}
      </span>
    </div>
  </div>
  <div class="pane-body">
    <div id="video-edit-tab" class="video-edit-tab" role="tabpanel">
      <div class="video-placeholder">Please select a video to edit</div>
    </div>

    <div id="video-search-tab" class="video-search-tab" role="tabpanel">
      <input type="text" placeholder="Search" name="query" autocomplete="off">
      <ul class="results"></ul>
    </div>

    <div id="video-upload-tab" class="upload-file-tab video-upload-tab" role="tabpanel">
      {{{ icon 'upload-color' 'Upload' }}}
      <p class="upload-file-tab__upload-instructions">
        Drag and drop files here or 
        <span class="upload-file-tab__file-upload-button">
          <button>click to upload</button>
          <input type="file" name="files" />
        </span>
      </p>

      <p>
        <small class="video-upload-tab__file-size-limit">Limit individual file sizes to 300kb or less.</small>
      </p>
    </div>

    <div id="upload-progress-tab" class="upload-progress-tab" style="display: none;">
      <h2>Uploading File</h2>
      <div class="progress-container"></div>
      <button>Cancel</button>
    </div>
  </div>
  <div class="pane-footer">
    <ul class="selected">
    </ul>
  </div>
</div>
